(function() {
    "use strict";

    if (!String.prototype.trimLeft) {
        var regex = /^\s*(.*)$/;
        
        String.prototype.trimLeft = function() {
            return this.replace(regex, "$1");
        };
    }
})();


// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.trimLeft.js